"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalStructuralBaseSchema = void 0;
const zod_1 = require("zod");
const SignalId_1 = require("./SignalId");
exports.SignalStructuralBaseSchema = zod_1.z.object({
    id: SignalId_1.SignalIdSchema,
    name: zod_1.z.string(),
});
//# sourceMappingURL=SignalStructuralBase.js.map